import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from './core/guards/auth.guard';
import { LayoutComponent } from './layouts/layout.component';
import { BarcodeReaderComponent } from './pages/screen-printing/barcode-reader/barcode-reader.component';
import { OrderPdfViewComponent } from './pages/orders/order-pdf-view/order-pdf-view.component';
//import { ViewPatternComponent } from './pages/patten/view-pattern/view-pattern.component';
const routes: Routes = [
  { path: 'pdf/order', component: OrderPdfViewComponent },
  { path: 'account', loadChildren: () => import('./account/account.module').then(m => m.AccountModule) },
  // tslint:disable-next-line: max-line-length
  { path: '', component: LayoutComponent, loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule), canActivate: [AuthGuard] },
  { path: 'pages', loadChildren: () => import('./extrapages/extrapages.module').then(m => m.ExtrapagesModule), canActivate: [AuthGuard] },
  { path: 'barcode-reader', component:BarcodeReaderComponent},

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule]
})

export class AppRoutingModule { }
